import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import RegionForm from '../components/forms/RegionForm';
import '../styles/EmployeeMaster.css';
import RegionTable from '../components/RegionTable';

const RegionEditModel = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route

  const [regionData, setRegionData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Show modal only if URL starts with /sbu/edit
  const showModal = location.pathname.startsWith('/region/edit');

  const handleCloseModal = () => {
    navigate('/region'); // Go back to list
  };

  // ✅ Fetch SBU details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getRegionId/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            setRegionData(data.data);
          } else {
            setRegionData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching Region by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal]);

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Region Master</h2>
      </div>

      {/* Table of SBUs */}
      <RegionTable />

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Region</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : regionData ? (
            <RegionForm regionId={id} initialData={regionData} /> // ✅ Pass data to form
          ) : (
            <p className="text-center">No data found for this Region.</p>
          )}
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default RegionEditModel;
